import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
  @Input() title: string;

  @Input() subTitle: string;

  @Output() closeClick = new EventEmitter<void>();

  @Input() closeButtonText = 'Fechar';

  @Input() submitButtonText = 'Salvar';

  @Input() closeButtonClass = "primary";

  onCloseClick = () => this.closeClick.emit();
}
